<script lang="ts">
    import { popup, type PopupSettings } from "@skeletonlabs/skeleton";

    import Caret from "$lib/assets/CaretDownSmall.svg";

    export let value: any;
    export let name: string;
    export let search_func: Function;
    export let do_search: Boolean;

    let current_value: any;

    const popup_settings: PopupSettings = {
        event: "click",
        target: "popup-filter-" + name,
        placement: "bottom",
        state: (e) => {
            if (e.state) {
                current_value = JSON.parse(JSON.stringify(value));
                do_search = false;
            } else {
                if (do_search) {
                    search_func();
                } else {
                    value = JSON.parse(JSON.stringify(current_value));
                }
            }
        },
    };
</script>

<button
    class="ml-2 rounded-lg box-border py-0 px-1 border-neutral-200 border border-solid hover:border-blue-500 transition duration-300"
    use:popup={popup_settings}
>
    <div class="px-2 py-1 flex items-center justify-center">
        <p>{name}</p>
        <img class="ml-1" src={Caret} alt="DownCaret" />
    </div>
</button>

<div data-popup="popup-filter-{name}" class="bg-white rounded-lg shadow-md transition duration-0">
    <div class="px-5 py-4">
        <slot />
        <hr class="!border-stone-400 h-0.5 my-3" />
        <span class="flex items-center">
            <button class="rounded-lg py-2 px-4 bg-secondary-500 transition duration-300 hover:shadow-md mr-3">
                Cancel
            </button>
            <button
                class="rounded-lg ml-auto py-2 px-4 bg-zinc-800 text-white transition duration-300 hover:shadow-md"
                on:click={() => {
                    do_search = true;
                }}
            >
                Accept
            </button>
        </span>
    </div>
</div>
